export const validateContactInputs = (form, errors, setErrors) => {
    const errorList = { ...errors };

    const fields = ['name', 'email', 'subject', 'countryCode', 'phone', 'message'];

    for (const field of fields) {
        if (field in form) errorList[field] = !form[field].length;
    }

    // LEAVING IN IF WE WANT TO CUSTOMISE MESSAGES
    //
    // if ('name' in form) {
    //     errorList.name = form.name ? '' : 'Name field is required';
    // }
    //
    // if ('email' in form) {
    //     errorList.email = form.email ? '' : 'Email field is required';
    // }
    //
    // if ('subject' in form) {
    //     errorList.subject = form.subject ? '' : 'Subject field is required';
    // }
    //
    // if ('countryCode' in form) {
    //     errorList.countryCode = form.countryCode ? '' : 'Code field is required';
    // }
    //
    // if ('phone' in form) {
    //     errorList.phone = form.phone ? '' : 'Phone field is required';
    // }
    //
    // if ('message' in form) {
    //     errorList.message = form.message ? '' : 'Message field is required';
    // }

    setErrors({
        ...errorList
    });

    const validated = Object.values(errorList).every((error) => !error);

    if (validated) return validated;
};
